export class StepProgressView {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "percentX100",
            "baseName": "percentX100",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "etaSeconds",
            "baseName": "etaSeconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "rate",
            "baseName": "rate",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "rateUnit",
            "baseName": "rateUnit",
            "type": "string",
            "format": ""
        },
        {
            "name": "progressAt",
            "baseName": "progressAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "snapshot",
            "baseName": "snapshot",
            "type": "Array<StepProgressSnapshotEntry>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StepProgressView.attributeTypeMap;
    }
    constructor() {
    }
}
